/* eslint-disable */
import * as React from 'react';
import injectSheet from 'react-jss';
import classNames from 'classnames';
import { Input } from './index';
import MobileDetect from '../../utils/mobileDetect';

const styleSheet = {
  input: {
    '&::placeholder': {
      textOverflow: 'ellipsis !important',
      color: '#b7c1e1',
    },
    '&:-ms-input-placeholder': {
      textOverflow: 'ellipsis !important',
      color: '#b7c1e1',
    },
    '&:focus': {
      border: 'solid 2px #085fe5'
    },
    '-webkit-appearance': 'none',
    outline: 0,
    width: '100%',
    height: '72px',
    objectFit: 'contain',
    borderRadius: '6px',
    border: 'solid 2px #b7c1e1',
    boxSizing: 'border-box',
    padding: '24px 27px',
    fontSize: '24px',
    color: '#4f5b84',
    fontFamily: 'CircularStd, sans-serif',
  },
  error: {
    borderColor: '#e60000 !important',
    transition: 'border 500ms',
  },
  label: {
    display: 'block',
    textAlign: 'left',
    paddingLeft: '9px',
    marginBottom: '14px',
    textTransform: 'uppercase',
    color: '#223762',
    fontWeight: '800',
  },
  hideOnMobile: {},
  wrapper: {
    flex: 1,
  },
  '@media (max-width: 900px)': {
    input: {
      height: '64px',
      fontSize: '20px',
    },
    label: {
      fontSize: '10px',
    },
    hideOnMobile: {
      display: 'none',
    },
  },
};

interface Props {
  // classes, placeholder, onChange, value, name, onBlur
  error?: boolean;
  label?: string;
  type: string;
  name: string;
  value?: string;
  classes?: any;
  placeholder?: string;
  onChange?: (e: object) => void;
  onBlur?: (e: React.FocusEvent<any>) => void;
}

const DateInput: React.FC<Props> = props => {
  const isMobile = MobileDetect.phone() ? true : false;

  const handleChange = (event: React.ChangeEvent<any>) => {
    //ensure only numbers and slashes//
    const check = /^[0-9]+$/;
    let str = event.target.value;

    let response = {
      value: str,
      name: event.target.name,
      fieldId: event.target.name,
    };

    // remove slashes to ensure only numbers exist
    let strNoSlashes = str.replace(/\//g, '');

    if (strNoSlashes.length >= 1 && strNoSlashes.length <= 8) {
      // if the regex is true//
      check.test(strNoSlashes);
      if (check.test(strNoSlashes)) {
        response.value = str
          .replace(/^(\d\d)(\d)$/g, '$1/$2')
          .replace(/^(\d\d\/\d\d)(\d+)$/g, '$1/$2')
          .replace(/[^\d\/]/g, '');

        props.onChange ? props.onChange({ target: response }) : null;
      }
    } else if (strNoSlashes.length <= 0) {
      response.value = '';
      props.onChange ? props.onChange({ target: response }) : null;
    }
  };

  if (!isMobile) {
    return (
      <div className={props.classes.wrapper}>
        <label
          className={classNames(props.classes.label, {
            [props.classes.hideOnMobile]: props.label.length == 1,
          })}
        >
          {props.label}
        </label>
        <input
          className={classNames(props.classes.input, {
            [props.classes.error]: props.error,
          })}
          placeholder={props.placeholder}
          type="text"
          name={props.name}
          aria-label={props.name}
          value={props.value}
          onChange={e => handleChange(e)}
          onBlur={props.onBlur}
          autoComplete={'on'}
        />
      </div>
    );
  } else {
    return <Input {...props} max={`${new Date()}`} min="1900-12-31" />;
  }
};

export default injectSheet(styleSheet)(DateInput);
